import { createContext, useState } from "react";

type BaseSnackBarContext = {
  isShow: boolean;
  text: string;
  openBaseSnackBar: (text: string) => void;
  closeBaseSnackBar: () => void;
};

const defaultContext: BaseSnackBarContext = {
  isShow: false,
  text: "",
  openBaseSnackBar: () => { /**intentionally empty */ },
  closeBaseSnackBar: () => { /**intentionally empty */ },
};

export const BaseSnackBarContext =
  createContext<BaseSnackBarContext>(defaultContext);

// custom Hook
export const useBaseSnackBar = (): BaseSnackBarContext => {
  const [isShow, setIsShow] = useState(false);
  const [text, setText] = useState("");

  const openBaseSnackBar = (text: string) => {
    setIsShow(true);
    setText(text);
  };
  const closeBaseSnackBar = () => {
    setIsShow(false);
  };

  return {
    isShow,
    text,
    openBaseSnackBar,
    closeBaseSnackBar,
  };
};
